import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changeStringToHyperLink'
})
export class ChangeStringToHyperLinkPipe implements PipeTransform {
  // 文章中のURL、メールアドレス、電話番号をハイパーリンクにする関数
  transform(value: any, args?: any): any {
    if (value) {
      const re_url = /((https?|ftp)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+))/gi;
      const re_mail = /(\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b)/gi;
      const re_tel = /(\d{2,5}[-(]\d{1,5}[-)]\d{3,4})/gi;

      // value = value.replace(/</gi, '[');
      // value = value.replace(/>/gi, ']');
      value = value.replace(
        re_url,
        '<a class="link" href="$1" target="_blank">$1</a>'
      );
      value = value.replace(
        re_mail,
        '<a class ="link" href="mailto:$1">$1</a>'
      );
      value = value.replace(re_tel, '<a class="link" href="tel:$1">$1</a>');

      return value;
    }
    return value;
  }
}
